// extracted by mini-css-extract-plugin
module.exports = {"regionFAQ":"styles_regionFAQ__3-OtM","boxFAQ":"styles_boxFAQ__CyqYa","descriptionRegion":"styles_descriptionRegion__3DegA"};